<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
	<div class="container" ref="viewBox">
		<div class="content">
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{$t('setting.text1')}}</span>
						</div>
						<div class="caption" style="background-color:#fff;padding:20px 20px;border-bottom: 1px solid rgb(239,239,239);">
							<span>{{username}}</span>
						</div>
						<div class="tag-outer">
							<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
								<el-tab-pane :label="$t('setting.text2')" name="first">
							    	<div>
							    		<el-alert
							    			v-if="profileStatus !== null && profileStatus !== undefined"
							    			:title="'资料审核：' + profileStatusText()"
							    			:type="profileStatus === PROFILE_STATUS.APPROVED ? 'success' : (profileStatus === PROFILE_STATUS.REJECTED ? 'error' : 'warning')"
							    			:description="profileStatus === PROFILE_STATUS.REJECTED && profileRejectReason ? ('驳回原因：' + profileRejectReason) : ''"
							    			show-icon
							    			:closable="false"
							    			style="margin-bottom: 16px;"
							    		/>
								    	<el-form v-if="!isMobile"
										    ref="ruleUserRef"
										    style="max-width: 600px"
										    :model="ruleUser"
										    status-icon
										    :rules="_rules"
										    label-width="auto"
										    class="demo-ruleForm"
										  >
										    <el-form-item :label="$t('form.photo')" prop="thumb">
											    <div class="list-item-img">	
													<label for="avatar_upload" class="list-item-img-outer" >
														<Loading :is-loading="isAvatarLoading"></Loading>
														<input type="file" id="avatar_upload" @change="uploadAvatar($event)" accept="image/*" style="display:none;" />
														<img v-if="!ruleUser.thumb" style="width:100%;height:100%;object-fit:contain;" src="@/assets/img/default.png" />
														<img v-if="ruleUser.thumb" style="width:100%;height:100%;object-fit:contain;" :src="ruleUser.thumb"/>
														<!-- <span class="repeat" v-if="item.hasSimilar">{{$t('apply_work.similar')}}</span> -->
														<!-- hasSimilar <div style="position:absolute;left:0;top:0;z-index:99;width:100%;height:100%;background-color:rgba(0,0,0,0.1);display:flex;justify-content: center;align-items: center;">
															<i class="iconfont icon-delete" style="color:white;font-size:18px;" @click.stop="del('image', index)"></i>
														</div> -->
													</label>
												</div>
											</el-form-item>
										    <el-form-item :label="$t('login.userName')" prop="username">
										      <el-input v-model="ruleUser.username" autocomplete="off" :placeholder="$t('login.userName')" />
										    </el-form-item>
										    <el-form-item :label="$t('setting.text3')" prop="mobile">
										      <el-input v-model="ruleUser.mobile" autocomplete="off" :placeholder="$t('form.mobile')" :readonly="mobileReadonly()" @change="handleChange($event)">
										      	<template #append v-if="mobileReadonly()">
										      		<el-button @click="enableMobileEdit">修改</el-button>
										      	</template>
										      </el-input>
										    </el-form-item>
										    <el-form-item v-if="showMobileCode()" :label="$t('codetip')" prop="code" class="form-code">
										        <el-input v-model="ruleUser.code" autocomplete="off" :placeholder="$t('codetip')">
										        	<template #append>
												        <el-button @click="getCodeMobile()" :disabled="disabled">{{$t('getCode')}}</el-button>
												    </template>
										        </el-input>
										    </el-form-item>
										    <el-form-item :label="$t('form.email')" prop="email">
										      <el-input v-model="ruleUser.email" autocomplete="off" :placeholder="$t('form.email')" :readonly="emailReadonly()">
										      	<template #append v-if="emailReadonly()">
										      		<el-button @click="enableEmailEdit">修改</el-button>
										      	</template>
										      </el-input>
										    </el-form-item>
										    <el-form-item :label="$t('organizationName')" prop="department">
										      <el-input v-model="ruleUser.department" autocomplete="off" :placeholder="$t('organizationName')" />
										    </el-form-item>
										    <el-form-item label="简介" prop="bio">
										      <el-input v-model="ruleUser.bio" type="textarea" :rows="3" autocomplete="off" placeholder="简介" />
										    </el-form-item>
										    
										    <el-form-item>
										      <el-button type="primary" @click="submitUser(ruleUserRef)">{{$t('submitText')}}</el-button>
										      
										    </el-form-item>
										</el-form>

										<el-form v-if="isMobile"
										    ref="ruleUserRef"
										    style="max-width: 600px"
										    :model="ruleUser"
										    status-icon
										    :rules="_rules"
										    label-width="auto"
										    class="demo-ruleForm"
										  >
										    
										    <el-form-item prop="username">
										      <el-input v-model="ruleUser.username" autocomplete="off" :placeholder="$t('login.userName')" />
										    </el-form-item>
										    <el-form-item prop="mobile">
										      <el-input v-model="ruleUser.mobile" autocomplete="off" :placeholder="$t('form.mobile')" :readonly="mobileReadonly()">
										      	<template #append v-if="mobileReadonly()">
										      		<el-button @click="enableMobileEdit">修改</el-button>
										      	</template>
										      </el-input>
										    </el-form-item>
										    <el-form-item v-if="showMobileCode()" prop="code" class="form-code">
										        <el-input v-model="ruleUser.code" autocomplete="off" :placeholder="$t('codetip')">
										        	<template #append>
												        <el-button @click="getCodeMobile()" :disabled="disabled">{{$t('getCode')}}</el-button>
												    </template>
										        </el-input>
										    </el-form-item>
										    <el-form-item prop="email">
										      <el-input v-model="ruleUser.email" autocomplete="off" :placeholder="$t('form.email')" :readonly="emailReadonly()">
										      	<template #append v-if="emailReadonly()">
										      		<el-button @click="enableEmailEdit">修改</el-button>
										      	</template>
										      </el-input>
										    </el-form-item>
										    <el-form-item prop="department">
										      <el-input v-model="ruleUser.department" autocomplete="off" :placeholder="$t('organizationName')" />
										    </el-form-item>
										    <el-form-item prop="bio">
										      <el-input v-model="ruleUser.bio" type="textarea" :rows="3" autocomplete="off" placeholder="简介" />
										    </el-form-item>
										    
										    <el-form-item>
										      <el-button type="primary" @click="submitUser(ruleUserRef)">{{$t('submitText')}}</el-button>
										      
										    </el-form-item>
										</el-form>
									</div>
							    </el-tab-pane>
							    <el-tab-pane :label="$t('editpassword')" name="second">
							    	<div>
								    	<el-form
										    ref="ruleFormRef"
										    style="max-width: 600px"
										    :model="ruleForm"
										    status-icon
										    :rules="rules"
										    label-width="auto"
										    class="demo-ruleForm"
										  >
										    <el-form-item :label="$t('newPassword')" prop="pass">
										      <el-input v-model="ruleForm.pass" type="password" autocomplete="off" show-password />
										    </el-form-item>
										    <el-form-item :label="$t('confirmPassword')" prop="checkPass">
										      <el-input
										        v-model="ruleForm.checkPass"
										        type="password"
										        autocomplete="off"
										        show-password
										      />
										    </el-form-item>
										    
										    <el-form-item>
										      <el-button type="primary" @click="submitForm(ruleFormRef)">{{$t('submitText')}}</el-button>
										    </el-form-item>
										</el-form>
									</div>
							    </el-tab-pane>
							    <el-tab-pane label="注销账号" name="third">
							    	<div style="max-width: 600px;">
							    		<el-alert title="注销后账号数据将无法恢复，请谨慎操作" type="warning" show-icon :closable="false" style="margin-bottom: 16px;" />
							    		<el-radio-group v-model="cancelMode" style="margin-bottom: 16px;">
							    			<el-radio label="password">密码验证</el-radio>
							    			<el-radio label="sms">短信验证</el-radio>
							    		</el-radio-group>
							    		<el-form v-if="cancelMode === 'password'" label-width="auto">
							    			<el-form-item label="密码">
							    				<el-input v-model="cancelForm.password" type="password" show-password autocomplete="off" />
							    			</el-form-item>
							    			<el-form-item label="确认密码">
							    				<el-input v-model="cancelForm.password_confirm" type="password" show-password autocomplete="off" />
							    			</el-form-item>
							    		</el-form>
							    		<el-form v-else label-width="auto">
							    			<el-form-item label="手机号">
							    				<el-input v-model="cancelForm.mobile" autocomplete="off" placeholder="手机号" />
							    			</el-form-item>
							    			<el-form-item label="验证码">
							    				<el-input v-model="cancelForm.code" autocomplete="off" placeholder="验证码">
							    					<template #append>
							    						<el-button @click="getCode(cancelForm.mobile)" :disabled="disabled">获取验证码</el-button>
							    					</template>
							    				</el-input>
							    			</el-form-item>
							    		</el-form>
							    		<el-button type="danger" :loading="cancelSubmitting" @click="submitCancelAccount">确认注销账号</el-button>
							    	</div>
							    </el-tab-pane>
							    
							</el-tabs>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</NewIndexSiteLayout>
</template>

<script>
	import setting from './setting_controller';
	export default setting;
</script>

<style src="@/assets/css/my/setting.css" scoped>
	/*@import url("@/assets/css/style.css");全局引用css*/
	/*@import '@/assets/css/style.css';*/
</style>